import React from 'react';
import Loader from "../Loader";
import TimeBasedSummary from "../TimeBasedSummary";
import _ from "lodash";

function OutOfRangeCard(props) {
    const {outOfRangeCount, timeFrameText, isLoading} = props;
    return (
        <div className="card facility-out-of-range">
            <div className="card-header">Out of Range</div>
            <div className="card-body d-flex align-items-stretch">
                {isLoading ? <Loader size="2x"/> : ''}
                <React.Fragment>
                    <TimeBasedSummary
                        label="Total Out of Range"
                        number={_.defaultTo(outOfRangeCount.total, 0)}
                        units="Instances"
                        timeFrameText={timeFrameText}
                        style={{marginTop: 15}}
                    />

                    <TimeBasedSummary
                        label="Average Out of Range"
                        number={_.defaultTo(outOfRangeCount.avg, 0)}
                        units="Instances"
                        timeFrameText={null}
                        timeFramePrefix="Per Room"
                        style={{marginTop: 15}}
                    />
                </React.Fragment>
            </div>
            <div className="card-footer">
                *For whole neighborhood based on time period selected above
            </div>
        </div>
    );
}

export default OutOfRangeCard;
